import { VisitOrderModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/visit-order-mode.enum";

export { VisitOrderModeEnum };

export const VISIT_ORDER_MODE_LABELS = {
  [VisitOrderModeEnum.SUB_ROUTE]: "Por subruta",
  [VisitOrderModeEnum.TRIP]: "Por viaje",
};

export const VISIT_ORDER_MODE_DESCRIPTIONS = {
  [VisitOrderModeEnum.SUB_ROUTE]: "Orden por defecto del maestro de rutas.",
  [VisitOrderModeEnum.TRIP]: "Orden propio del viaje, calculado por el optimizador o editado manualmente.",
};

export interface VisitOrderModeItem {
  code: VisitOrderModeEnum;
  value: string;
  description: string;
}

export const VISIT_ORDER_MODE_LIST: VisitOrderModeItem[] = [
  {
    code: VisitOrderModeEnum.SUB_ROUTE,
    value: VISIT_ORDER_MODE_LABELS[VisitOrderModeEnum.SUB_ROUTE],
    description: VISIT_ORDER_MODE_DESCRIPTIONS[VisitOrderModeEnum.SUB_ROUTE],
  },
  {
    code: VisitOrderModeEnum.TRIP,
    value: VISIT_ORDER_MODE_LABELS[VisitOrderModeEnum.TRIP],
    description: VISIT_ORDER_MODE_DESCRIPTIONS[VisitOrderModeEnum.TRIP],
  },
];
